import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, DropdownToggle, DropdownMenu, DropdownItem, Dropdown } from 'reactstrap';
import { Btn, H4 } from '../../../../AbstractElements';
import { Invoice, Transactions, Reciept, ViewMore, PaymentHistory, Export, Order } from '../../../../Constant';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../../Utils/restUtils';
import { getOrderInvoice, getOrderInvoiceRole, getPaymentHistory, getPaymentHistoryRole, getRecentInvoice, getRecentInvoiceRole, getRecentPayment, getRecentPaymentRole, reversePayment } from '../../../../CommonUrl';
import { conditionalRowPayments } from '../../../Common/Rowstyle/Rowstyle';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { InvoiceColumns, OrderColumns, paymentHistoryColumns } from './HeaderColumn';

const PayInvoiceTabs = (props) => {
    const propsId = props.param;
    const style2 = { width: 85, fontSize: 13, padding: 5 };
    const [PrimarycolorLineTab, setPrimarycolorLineTab] = useState('1');
    const authState = useSelector((state) => state.auth);
    const [invoiceList, setInvoiceList] = useState([]);
    const [orderList, setOrderList] = useState([]);
    const [transactionlist, setTransaction] = useState([])
    const [paymentHistorylist, setPaymentHistory] = useState([])
    const [totalRows, setTotalRows] = useState(0);
    const [totalPaymentRows, setpaymentTotalRows] = useState(0);
    const [totalPaymentHistoryRows, setPaymentHistoryTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPaymentPage, setPaymentCurrentPage] = useState(1);
    const [currentPaymentHistoryPage, setPaymentHistoryCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const navigate = useNavigate();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const transactionColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            width: '50px'
            // center: true,
        },
        {
            name: <H4>Action</H4>,
            selector: row => row.Action,
            cell: row => <ActionCell row={row} />,
            center: true,
            width: '100px',
        },
        {
            name: <H4>Receipt No</H4>,
            selector: row =>
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${row.payment_id}`}>
                    {row.payment_id}
                </Link>,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Paid On</H4>,
            selector: row => row.Paidat,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Txn Id</H4>,
            selector: row => row.txnId,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Bin reflected</H4>,
            selector: row => row.bin,
            sortable: true,
            center: true,
            // width: '165px'
        },
        {
            name: <H4>Amount Collected</H4>,
            selector: row => row.Amount,
            sortable: true,
            wrap: true,
            // width: '110px'
        },
        {
            name: <H4>To Invoice</H4>,
            selector: row => row.toInvoice,
            sortable: true,
            center: true,
            // width: '165px'
        },
        {
            name: <H4>To Wallet</H4>,
            selector: row => row.toWallet,
            sortable: true,
            center: true,
            // width: '135px'
        },

        {
            name: <H4>Sales agent</H4>,
            selector: row => row.payBy,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Payment Method</H4>,
            selector: row => row.payment_method,
            sortable: true,
            center: true,
        },
        {
            name: <H4>Payment Type</H4>,
            selector: row => row.payType,
            sortable: true,
            center: true,
        },
    ];

    useEffect(() => {
        invoiceData(1); // do not put await here
        orderData(1); 
        transactionData(1);
        paymentHistoryData(1);
    }, []);

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handlePageChange = page => {
        invoiceData(page);
        setCurrentPage(page);
    };

    const handlePaymentPageChange = page => {
        transactionData(page);
        setPaymentCurrentPage(page);
    };

    const handlePaymentHistoryPageChange = page => {
        paymentHistoryData(page);
        setPaymentHistoryCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        invoiceData(page, newPerPage);
        transactionData(page, newPerPage);
        paymentHistoryData(page, newPerPage);
        setPerPage(newPerPage);
    };

    const redirectToInvoice = (data) => {
        const editFormURL = `${process.env.PUBLIC_URL}/customers/customer/userProfile/invoice?invoice_id=${data.order_id}&customer_id=${propsId}`;
        navigate(editFormURL);
    };

    const redirectToReciept = (id) => {
        const toReciept = `${process.env.PUBLIC_URL}/billing/thermal-print?payment_id=${id}`;
        navigate(toReciept);
    };

    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const deleteTransaction = () => {
            SweetAlert.fire({
                title: 'Confirm deletion?',
                text: 'This action cannot be undone.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setLoading(true);
                if (result.value) {
                    const deleteRes = { payment_id: row.payment_id }
                    const transactionDelete = await postClientUrlWithToken(authState.apiUrl, reversePayment, deleteRes);
                    if (transactionDelete.status === 200) {
                        if (transactionDelete.data.status === true) {
                            SweetAlert.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            );
                            window.location.reload();
                            setLoading(false);
                        }
                        else {
                            toast.error(transactionDelete.data.message);
                        }
                    } else {
                        handleApiError(transactionDelete.status);
                    }
                }
            });
        };
        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ padding: '6px 12px', fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    <DropdownItem style={toggleStyle} onClick={() => redirectToReciept(row.payment_id)}>Reciept</DropdownItem>
                    {authState.userRole === 1 &&
                        <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' }} onClick={() => deleteTransaction(row.payment_id)}>Delete</DropdownItem>
                    }
                </DropdownMenu>
            </Dropdown>
        );
    };

    const invoiceData = async (page, size = perPage) => {
        setLoading(true)
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRecentInvoice + `?customer_id=${propsId}&page=${page}&page_length=${size}` :
            getRecentInvoiceRole + `?customer_id=${propsId}&page=${page}&page_length=${size}`);

        if (data.status === true) {
            setInvoiceList(data.data.data.map((e, index) => {
                const tax = e.tax.replace(/\.?0+$/, '');
                return {
                    Si: index + 1,
                    Subscription: e.subscription_name,
                    Invoice: e.invoice_number,
                    InvoiceDate: e.billing_date,
                    DueDate: e.due_date,
                    AmountDue: <span className='text-danger' style={{ fontWeight: 'bold' }}>{authState.currency + " " + e.amount_due}</span>,
                    Total: authState.currency + " " + e.total,
                    Customer: e.customer_name,
                    Status: e.payment_status,
                    UnitPrice: e.unit_price !== null ? authState.currency + " " + e.unit_price : e.unit_price,
                    order_id: e.order_id,
                    bin_account: e.bin_account,
                    id: e.id,
                    customerid: e.customer_id,
                    Tax: authState.currency + " " + tax,
                    CreatedAt: e.created_date,
                    action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToInvoice(e) }}>{ViewMore}</Btn>
                            </span>
                        </div>
                }
            }))
            setTotalRows(data.data.total);
            setLoading(false);
        } else {
            handleApiError(data.status);
        }
    };

    const orderData = async (page, size = perPage) => {
        setLoading(true)
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getOrderInvoice + `?customer_id=${propsId}&page=${page}&page_length=${size}` :
            getOrderInvoiceRole + `?customer_id=${propsId}&page=${page}&page_length=${size}`);

        if (data.status === true) {
            setOrderList(data.data.data.map((e, index) => {
                const tax = e.tax.replace(/\.?0+$/, '');
                return {
                    Si: index + 1,
                    Subscription: e.subscription_name,
                    Invoice: e.invoice_number,
                    InvoiceDate: e.billing_date,
                    DueDate: e.due_date,
                    AmountDue: <span className='text-danger' style={{ fontWeight: 'bold' }}>{authState.currency + " " + e.amount_due}</span>,
                    Total: authState.currency + " " + e.total,
                    Customer: e.customer_name,
                    Status: e.payment_status,
                    UnitPrice: e.unit_price !== null ? authState.currency + " " + e.unit_price : e.unit_price,
                    order_id: e.order_id,
                    bin_account: e.bin_account,
                    id: e.id,
                    customerid: e.customer_id,
                    Tax: authState.currency + " " + tax,
                    CreatedAt: e.created_date,
                    action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToInvoice(e) }}>{ViewMore}</Btn>
                            </span>
                        </div>
                }
            }))
            setTotalRows(data.data.total);
            setLoading(false);
        } else {
            handleApiError(data.status);
        }
    };

    const transactionData = async (page, size = perPage) => {
        setLoading(true)
        const transaction_api = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRecentPayment + `?customer_id=${propsId}&page=${page}&page_length=${size}`
            : getRecentPaymentRole + `?customer_id=${propsId}&page=${page}&page_length=${size}`)
        if (transaction_api.status === true) {
            const paymentData = transaction_api.data.data;
            setTransaction(paymentData.map((e, index) => {
                return {
                    Si: index + 1,
                    payment_id: e.id,
                    Name: e.customer_name,
                    Paidat: e.paid_date,
                    txnId: e.transaction_id,
                    payType: e.payment_type,
                    bin: e.bins,
                    payBy: e.created_name,
                    bin_reflected: e.bin_reflected,
                    payment_method: e.payment_method_name,
                    Amount: authState.currency + " " + e.paid_amount,
                    toInvoice: authState.currency + " " + e.to_invoice,
                    toWallet: authState.currency + " " + e.to_wallet,
                }
            }))
            setpaymentTotalRows(transaction_api.data.total);
            setLoading(false)
        } else {
            handleApiError(transaction_api.status);
        }
    }

    const exportTransactionExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRecentPayment + `?customer_id=${propsId}&export=transaction` :
            getRecentPaymentRole + `?customer_id=${propsId}&export=transaction`)
        const dataToExport = response.data.map(({ id, paid_date, transaction_id, bins, paid_amount, to_invoice, to_wallet, created_name, payment_method_name, payment_type }) => ({ Receipt_no: id, Paid_on: paid_date, Txn_id: transaction_id, Bin_reflected: bins, Amount_collected: paid_amount, To_Invoice: to_invoice, To_Wallet: to_wallet, Sales_agent: created_name, Payment_Method: payment_method_name, Payment_Type: payment_type }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Payment Data');
            XLSX.writeFile(wb, 'Transaction_data.xlsx');
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    const exportTransactionPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getRecentPayment + `?customer_id=${propsId}&export=transaction` :
            getRecentPaymentRole + `?customer_id=${propsId}&export=transaction`)
        const dataToExport = response.data.map(({ id, paid_date, transaction_id, bins, paid_amount, to_invoice, to_wallet, created_name, payment_method_name, payment_type }, index) => ({ Sl: index + 1, id, paid_date, transaction_id, bins, paid_amount, to_invoice, to_wallet, created_name, payment_method_name, payment_type }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ['SI', "Receipt No", "Paid On", "Txn Id", "Bin Id", "Amount Collected", "To invoice", "To Wallet", "Sales Agent", "Payment Method", "Payment Type"];
            const rows = dataToExport.map(({ id, paid_date, transaction_id, bins, paid_amount, to_invoice, to_wallet, created_name, payment_method_name, payment_type }, index) => [index + 1, id, paid_date, transaction_id, bins, paid_amount, to_invoice, to_wallet, created_name, payment_method_name, payment_type]);
            doc.autoTable({
                head: [columns],
                body: rows,
            });
            doc.save("Transaction_data.pdf");
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    const paymentHistoryData = async (page, size = perPage) => {
        setLoading(true)
        const payment_api = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getPaymentHistory + `?customer_id=${propsId}&page=${page}&page_length=${size}` :
            getPaymentHistoryRole + `?customer_id=${propsId}&page=${page}&page_length=${size}`)
        if (payment_api.status === true) {
            const paymentData = payment_api.data.data;
            setPaymentHistory(paymentData.map((e, index) => {
                return {
                    Si: index + 1,
                    payment_id: e.payment_id,
                    Name: e.customer_name,
                    Paidat: e.date,
                    txnId: e.transaction_id,
                    payType: e.payment_type,
                    Amount: authState.currency + e.collected_amount,
                    RefInvoice: e.invoice_number,
                    Bin: e.bin_account,
                    order_id: e.order_id,
                    payment_method: e.payment_method_name,
                    paid_user: e.created_name,
                    Action:
                        <div>
                            <span>
                                <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToReciept(e.payment_id) }}>{Reciept}</Btn>
                            </span>
                        </div >
                }
            }))
            setPaymentHistoryTotalRows(payment_api.data.total);
            setLoading(false)
        } else {
            handleApiError(payment_api.status);
        }
    }

    const exportPaymentExcel = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getPaymentHistory + `?customer_id=${propsId}&export=transaction` :
            getPaymentHistoryRole + `?customer_id=${propsId}&export=transaction`)
        const dataToExport = response.data.map(({ payment_id, date, transaction_id, collected_amount, invoice_number, bin_account, payment_method_name, paid_user }) => ({ Receipt_no: payment_id, Paid_on: date, Transaction_id: transaction_id, Amount: collected_amount, Reflected_Invoice: invoice_number, Bin_Reflected: bin_account, Payment_Method: payment_method_name, Sales_Agent: paid_user }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'History Data');
            XLSX.writeFile(wb, 'Payment_history.xlsx');
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };
    const exportPaymentPdf = async () => {
        setLoading(true);
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getPaymentHistory + `?customer_id=${propsId}&export=transaction` :
            getPaymentHistoryRole + `?customer_id=${propsId}&export=transaction`);
        const dataToExport = response.data.map(({ payment_id, date, transaction_id, collected_amount, invoice_number, bin_account, payment_method_name, paid_user }, index) => ({ Sl: index + 1, payment_id, date, transaction_id, collected_amount, invoice_number, bin_account, payment_method_name, paid_user }));
        if (response.status === true) {
            const doc = new jsPDF();
            const columns = ["SI", "Receipt No", "Paid On", "Txn Id", "Amount Collected", "Reflected Invoice", "Bin", "Payment Method", "Sales Agent"];
            const rows = dataToExport.map(({ payment_id, date, transaction_id, collected_amount, invoice_number, bin_account, payment_method_name, paid_user }, index) => [index + 1, payment_id, date, transaction_id, collected_amount, invoice_number, bin_account, payment_method_name, paid_user]);
            doc.autoTable({
                head: [columns],
                body: rows,
            });
            doc.save("Payment_history.pdf");
        } else {
            handleApiError(response.status);
        }
        setLoading(false);
    };

    return (
        <>
            <Col sm="12" xl="6 xl-100">
                <Card>
                    <CardBody>
                        {PrimarycolorLineTab === '2' && (
                            <Dropdown className='ms-2' isOpen={dropdownOpen} toggle={toggleDropdown} style={{ float: 'right', marginRight: '10px' }}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                    {Export} <i className="icofont icofont-arrow-up"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => exportTransactionExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportTransactionPdf()}><i className="fa fa-file-excel-o me-2"></i> Pdf</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        )}
                        {PrimarycolorLineTab === '3' && (
                            <Dropdown className='ms-2' isOpen={dropdownOpen} toggle={toggleDropdown} style={{ float: 'right', marginRight: '10px' }}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                    {Export} <i className="icofont icofont-arrow-up"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => exportPaymentExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportPaymentPdf()}><i className="fa fa-file-excel-o me-2"></i> Pdf</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        )}
                        <Nav className="border-tab nav-primary" tabs>
                            <NavItem>
                                <NavLink className={PrimarycolorLineTab === '1' ? 'active' : ''} style={{ cursor: 'pointer' }} onClick={() => setPrimarycolorLineTab('1')}>{Invoice}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={PrimarycolorLineTab === '2' ? 'active' : ''} style={{ cursor: 'pointer' }} onClick={() => setPrimarycolorLineTab('2')}>{Order}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={PrimarycolorLineTab === '3' ? 'active' : ''} style={{ cursor: 'pointer' }} onClick={() => setPrimarycolorLineTab('3')}>{Transactions}</NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={PrimarycolorLineTab === '4' ? 'active' : ''} style={{ cursor: 'pointer' }} onClick={() => setPrimarycolorLineTab('4')}>{PaymentHistory}</NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={PrimarycolorLineTab}>
                            <TabPane className="fade show" tabId="1">
                                <div className="order-history table-responsive" style={{ marginTop: '-15px' }}>
                                    <DataTable
                                        data={invoiceList}
                                        columns={InvoiceColumns(propsId)}
                                        pagination
                                        progressPending={loading}
                                        paginationServer
                                        defaultSortAsc
                                        paginationTotalRows={totalRows}
                                        paginationDefaultPage={currentPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        conditionalRowStyles={conditionalRowPayments}
                                        style={{ border: '1px solid' }}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tabId="2">
                                <div className="order-history table-responsive" style={{ marginTop: '-15px' }}>
                                    <DataTable
                                        data={orderList}
                                        columns={OrderColumns(propsId)}
                                        pagination
                                        progressPending={loading}
                                        paginationServer
                                        defaultSortAsc
                                        paginationTotalRows={totalRows}
                                        paginationDefaultPage={currentPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        conditionalRowStyles={conditionalRowPayments}
                                        style={{ border: '1px solid' }}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tabId="3">
                                <div className="order-history table-responsive" style={{ marginTop: '-15px' }}>
                                    <DataTable
                                        data={transactionlist}
                                        columns={transactionColumns}
                                        pagination
                                        progressPending={loading}
                                        paginationServer
                                        defaultSortAsc
                                        paginationTotalRows={totalPaymentRows}
                                        paginationDefaultPage={currentPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePaymentPageChange}
                                        style={{ border: '1px solid' }}
                                    />
                                </div>
                            </TabPane>
                            <TabPane tabId="4">
                                <div className="order-history table-responsive" style={{ marginTop: '-15px' }}>
                                    <DataTable
                                        data={paymentHistorylist}
                                        columns={paymentHistoryColumns(propsId)}
                                        pagination
                                        progressPending={loading}
                                        paginationServer
                                        defaultSortAsc
                                        paginationTotalRows={totalPaymentHistoryRows}
                                        paginationDefaultPage={currentPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePaymentHistoryPageChange}
                                        style={{ border: '1px solid' }}
                                    />
                                </div>
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </Col>
        </>
    );
};

export default PayInvoiceTabs;